module.exports = __webpack_public_path__ + "media/images/pc/special_plans/icon_leaf-67efa092e47f9c17bd031bfd866262f9.png";